import { render, staticRenderFns } from "./IMedal.vue?vue&type=template&id=0c9a1a96&"
import script from "./IMedal.vue?vue&type=script&lang=ts&"
export * from "./IMedal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports